import React from "react";
import { Link, useLocation } from "react-router-dom";
import { getAlternateRoute } from "@/lib/i18n/routeMap";

const LanguageSwitcher: React.FC = () => {
  const location = useLocation();
  const isSpanish = location.pathname.startsWith("/es");
  const currentLang = isSpanish ? "es" : "en";

  return (
    <div className="inline-flex items-center gap-1.5 text-xs font-semibold text-muted">
      <svg
        className="w-4 h-4 text-muted"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.8}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 3a9 9 0 100 18 9 9 0 000-18zm0 0c2.5 2.6 4 6 4 9s-1.5 6.4-4 9m0-18C9.5 5.6 8 9 8 12s1.5 6.4 4 9m-7.5-9h15"
        />
      </svg>
      <div className="flex items-center p-0.5 border rounded-md border-border">
        <Link
          to={
            currentLang === "en"
              ? location.pathname
              : getAlternateRoute(location.pathname, "en")
          }
          className={`inline-flex items-center justify-center min-w-11 h-11 sm:min-w-10 sm:h-10 rounded text-xs font-semibold transition-colors ${
            currentLang === "en"
              ? "bg-surface-sunken text-primary"
              : "text-secondary hover:text-accent-text"
          }`}
          aria-current={currentLang === "en" ? "page" : undefined}
        >
          EN
        </Link>
        <Link
          to={
            currentLang === "es"
              ? location.pathname
              : getAlternateRoute(location.pathname, "es")
          }
          className={`inline-flex items-center justify-center min-w-11 h-11 sm:min-w-10 sm:h-10 rounded text-xs font-semibold transition-colors ${
            currentLang === "es"
              ? "bg-surface-sunken text-primary"
              : "text-secondary hover:text-accent-text"
          }`}
          aria-current={currentLang === "es" ? "page" : undefined}
        >
          ES
        </Link>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
